export const CareerGoalsGroupStepController = [
    '$scope',
    function($scope) {
        $scope.groupName = $scope.registrationSettings.WhitelabelSettings['customized:careerGoals'] || 'Career Goals';
        $scope.withHero = false; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 5; // the last step number of this group
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/careerGoals.html';
        const skipConsultationTypes = $scope.registrationSettings.WhitelabelSettings['hideField:consultationTypes'];

        if (skipConsultationTypes.skip) {
            $scope.registrationData.DesiredConsultationTypes.reset();
            skipConsultationTypes.default.forEach(consultationTypeId =>
            $scope.registrationData.DesiredConsultationTypes.add($scope.registrationSettings.VerticalServices.get(consultationTypeId)));

            $scope.localStep = $scope.finalStep + 1;
            $scope.goToNextStep(false);
        }

        // if the localStep is -1, we need to go to the very last step
        if ($scope.localStep === -1) {
            $scope.localStep = $scope.finalStep;
        }

        // here we determine what the data criteria is before we show the Next button
        switch ($scope.localStep) {
            case 0:
                $scope.withHero = true;
                $scope.minInputTop = 0;
                if ($scope.registrationSettings.WhitelabelSettings['registrationSkipCareerGoalsSplash']) {
                    $scope.skipThisStep();
                }
                break;

            case 1:
                $scope.$watch('registrationData.DesiredConsultationTypes.length', function(newVal) {
                    $scope.showNext = newVal >= 1;
                });
                $scope.$on('goToNextStep', function() {
                    $scope.goToNextStep();
                });
                break;

            case 2:
                if ($scope.registrationSettings.WhitelabelSettings['hideField:careerGoal_locations']) {
                    $scope.skipThisStep();
                    break;
                }
                $scope.$watch('registrationData.CareerGoals.Locations.length', function(newVal) {
                    $scope.showNext = newVal >= 1;
                });
                break;

            case 3:
                if ($scope.registrationSettings.WhitelabelSettings['hideField:careerGoal_industries']) {
                    $scope.skipThisStep();
                    break;
                }
                $scope.industryRequired = $scope.registrationSettings.WhitelabelSettings['requiredField:careerGoal_industries']
                $scope.$watch('registrationData.CareerGoals.Industries.length', function(newVal) {
                    $scope.showNext = newVal >= 1;
                });
                break;

            case 4:
                if ($scope.registrationSettings.WhitelabelSettings['hideField:careerGoal_employers']) {
                    $scope.skipThisStep();
                    break;
                }
                $scope.$watch('registrationData.CareerGoals.Employers.length', function(newVal) {
                    $scope.showNext = newVal >= 1;
                });
                break;

            case 5:
                if ($scope.registrationSettings.WhitelabelSettings['hideField:careerGoal_functions']) {
                    $scope.skipThisStep();
                    break;
                }
                $scope.$watch('registrationData.CareerGoals.Roles.length', function(newVal) {
                    $scope.showNext = newVal >= 1;
                });
                break;
        }
    },
];
